<div class="dx-card wide-card">
    <div *ngIf="showGrid">
        <div class="leftmargin topmargin">
            <h4 class="ap-green">ASU and HyCO Investment Details</h4>
        </div>
        <dx-data-grid id="gridContainer" class="fixGridHght" [dataSource]="dataSource" [allowColumnReordering]="true"
            [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true"
            [rowAlternationEnabled]="true" [columnHidingEnabled]="false" [allowColumnResizing]="false">
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-selection mode="single" showCheckBoxesMode="always"></dxo-selection>
            <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
                [showInfo]="true" [showNavigationButtons]="true">
            </dxo-pager>
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button class="ap-blue-btn" text="Reset" (onClick)="resetFilters()">
                    </dx-button>
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxi-column dataField="awardYear" caption="Award Year"></dxi-column>
            <dxi-column dataField="offeringType" caption="Offering Type"></dxi-column>
            <dxi-column dataField="dealType" caption="Deal Type"></dxi-column>
            <dxi-column dataField="businessModel" caption="Business Model"></dxi-column>
            <dxi-column dataField="tgeeregions" caption="Region"></dxi-column>
            <dxi-column dataField="chinavsRow" caption="China vs ROW"></dxi-column>
            <dxi-column dataField="countryName" caption="Country"></dxi-column>
            <dxi-column dataField="competitor" caption="Competitor"></dxi-column>
            <dxi-column dataField="status" caption="Status"></dxi-column>
            <dxi-column dataField="primaryMaterial" caption="Primary Material"></dxi-column>
            <dxi-column dataField="quantity" caption="Quantity"></dxi-column>
            <dxi-column dataField="units" caption="Units"></dxi-column>
            <dxi-column dataField="totalCostEstimateMmusd" caption="Total Cost Estimate MMUSD"></dxi-column>
            <dxi-column dataField="announcementTitle" caption="Announcement Title"></dxi-column>
            <dxi-column dataField="notes" [width]="300" caption="Notes"></dxi-column>
            <dxi-column dataField="productionFacilityId" caption="Facility ID" width="100"></dxi-column>
        </dx-data-grid>
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>